"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const certifications_1 = require("../certifications");
const changes_1 = require("../changes");
const collections_1 = require("../collections");
const companies_1 = require("../companies");
const configuration_1 = require("../configuration");
const credits_1 = require("../credits");
const discover_1 = require("../discover");
const genres_1 = require("../genres");
const movies_1 = require("../movies");
const trending_1 = require("../trending");
const find_1 = require("../find");
const guest_sessions_1 = require("../guest-sessions");
const keywords_1 = require("../keywords");
const account_1 = require("../account");
const authentication_1 = require("../authentication");
const lists_1 = require("../lists");
const networks_1 = require("../networks");
const people_1 = require("../people");
const reviews_1 = require("../reviews");
const search_1 = require("../search");
const tv_shows_1 = require("../tv-shows");
const watch_providers_1 = require("../watch-providers");
const tv_episodes_1 = require("../tv-episodes");
const tv_seasons_1 = require("../tv-seasons");
const tv_episode_groups_1 = require("../tv-episode-groups");
class Wrapper {
    account;
    authentication;
    certifications;
    changes;
    collections;
    companies;
    configuration;
    credits;
    discover;
    find;
    genres;
    guestSessions;
    keywords;
    lists;
    movies;
    networks;
    people;
    reviews;
    search;
    trending;
    tvShows;
    tvEpisodes;
    tvSeasons;
    tvEpisodeGroups;
    watchProviders;
    constructor(options) {
        this.account = new account_1.AccountAPI(options);
        this.authentication = new authentication_1.AuthenticationAPI(options);
        this.certifications = new certifications_1.CertificationsAPI(options);
        this.changes = new changes_1.ChangesAPI(options);
        this.collections = new collections_1.CollectionsAPI(options);
        this.companies = new companies_1.CompaniesAPI(options);
        this.configuration = new configuration_1.ConfigurationAPI(options);
        this.credits = new credits_1.CreditsAPI(options);
        this.discover = new discover_1.DiscoverAPI(options);
        this.find = new find_1.FindAPI(options);
        this.genres = new genres_1.GenresAPI(options);
        this.guestSessions = new guest_sessions_1.GuestSessionsAPI(options);
        this.keywords = new keywords_1.KeywordsAPI(options);
        this.lists = new lists_1.ListsAPI(options);
        this.movies = new movies_1.MoviesAPI(options);
        this.networks = new networks_1.NetworksAPI(options);
        this.people = new people_1.PeopleAPI(options);
        this.reviews = new reviews_1.ReviewsAPI(options);
        this.search = new search_1.SearchAPI(options);
        this.trending = new trending_1.TrendingAPI(options);
        this.tvShows = new tv_shows_1.TVShowsAPI(options);
        this.tvEpisodes = new tv_episodes_1.TVEpisodesAPI(options);
        this.tvSeasons = new tv_seasons_1.TVSeasonsAPI(options);
        this.tvEpisodeGroups = new tv_episode_groups_1.TVEpisodeGroupsAPI(options);
        this.watchProviders = new watch_providers_1.WatchProvidersAPI(options);
    }
}
exports.Wrapper = Wrapper;
